import { useState, useEffect } from "react"
import { Layer, Source } from "react-map-gl/mapbox"
import type { Feature, FeatureCollection } from "geojson"

interface IsochroneLayerProps {
  profile: "walking" | "driving" | "cycling"
  center: [number, number]
  opacity?: number
}

export const IsochroneLayer = ({ profile, center, opacity = 0.5 }: IsochroneLayerProps) => {
  const [lng, lat] = center
  const [data, setData] = useState<FeatureCollection | null>(null)

  const mapboxToken = import.meta.env.VITE_MAPBOX_TOKEN || ""

  useEffect(() => {
    if (lng == null || lat == null) return
    let cancelled = false
    fetch(
      `https://api.mapbox.com/isochrone/v1/mapbox/${profile}/${lng},${lat}?contours_minutes=10,20,30&polygons=true&access_token=${mapboxToken}`,
    )
      .then((res) => res.json())
      .then((json) => {
        if (!cancelled) setData(json)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [profile, lng, lat, mapboxToken])

  if (!data?.features) return null

  return (
    <>
      {data.features.map((feature: Feature, index: number) => (
        <Source key={`iso-${profile}-${index}`} id={`iso-${profile}-${index}`} type="geojson" data={feature}>
          <Layer
            id={`iso-${profile}-fill-${index}`}
            type="fill"
            paint={{
              "fill-color": feature?.properties?.fillColor,
              "fill-opacity": opacity * 0.6,
            }}
          />
        </Source>
      ))}
    </>
  )
}
